module.exports = __webpack_public_path__ + "img/top.18a207de.png";